import firebase from 'firebase/app';

const contactUs = 'Please contact the technology department.';
const thisShouldntHappen = "This shouldn't happen.";
const tryAgainOrContact = 'Please try again or contact the technology department.';
const youAreOnYourOwn =
  "You can contact the technology department, but you're probably on your own.";

const shouldntHappenTryAgain = `${thisShouldntHappen} ${tryAgainOrContact}`;

const unknownError = `An unknown error occurred. ${shouldntHappenTryAgain}`;
const unauthenticated = `You're currently unauthenticated. Please sign in and try again.`;

const friendlyFirestoreMapping: Record<firebase.firestore.FirestoreErrorCode, string> = {
  cancelled: 'The operation was cancelled.',
  unknown: unknownError,
  'invalid-argument': `An invalid argument was provided by the system. ${shouldntHappenTryAgain}`,
  'deadline-exceeded': `The operation took too long. ${tryAgainOrContact}`,
  'not-found': `Some requested document was not found. ${tryAgainOrContact}`,
  'already-exists': `Some document that you attempted to create already exists. ${tryAgainOrContact}`,
  'permission-denied': 'You do not have permission to access this resource.',
  'resource-exhausted': `Some resource has been exhausted. ${shouldntHappenTryAgain}`,
  'failed-precondition': `The operation was rejected because the system is not in a state required for the operation's execution. ${shouldntHappenTryAgain}`,
  aborted: 'The operation was cancelled.',
  'out-of-range': `The operation was attempted past the valid range. ${shouldntHappenTryAgain}`,
  unimplemented: `The operation is not implemented or not supported/enabled. ${shouldntHappenTryAgain}`,
  internal: `Something has gone horribly wrong and it's not our fault. ${youAreOnYourOwn}`,
  unavailable: `The service is currently unavailable. Please try again.`,
  'data-loss': `Unrecoverable data loss or corruption. ${youAreOnYourOwn}`,
  unauthenticated: unauthenticated,
};

export function mapFirestoreError(error: firebase.firestore.FirestoreError) {
  return `${friendlyFirestoreMapping[error.code]} Firebase Error Code: ${error.code}`;
}

const friendlyAuthMapping: Record<string, string> = {
  'auth/wrong-password': 'Incorrect password.',
  'auth/timeout': `Operation timed out. ${tryAgainOrContact}`,
  'auth/too-many-requests':
    'Due to unusual activity, you have been temporarily blocked from signing in. Try again later.',
  'auth/user-not-found': 'A user with this email was not found.',
};

// The list of all auth errors is massive so we'll handle a few common ones for now. This list should be expanded as features like account creation are added.
export function mapAuthError(error: firebase.auth.AuthError) {
  return (
    friendlyAuthMapping[error.code] ??
    `Failed to sign in. Firebase Error Code: ${error.code}. Firebase Error Message: ${error.message}`
  );
}

const fileUploadLimit = '5MB';

const someoneMessedUp = `Someone on the technology team messed up. ${contactUs}`;
const incorrectUpload = `The server determined that the file was uploaded incorrectly. ${tryAgainOrContact}`;

const friendlyStorageMapping: Record<string, string> = {
  'storage/unknown': unknownError,
  'storage/object-not-found': `The resource you tried to access does not exist. ${tryAgainOrContact}`,
  'storage/bucket-not-found': `Cloud Storage was misconfigured. ${contactUs}`,
  'storage/project-not-found': `Cloud Storage was misconfigured. ${contactUs}`,
  'storage/quota-exceeded': `We currently have too many files in storage. ${thisShouldntHappen} ${contactUs}`,
  'storage/unauthenticated': unauthenticated,
  'storage/unauthorized': `You do not have permission to do that. If you're uploading a file, make sure it's under ${fileUploadLimit}. If you believe this is a mistake, contact the technology department.`,
  'storage/retry-limit-exceeded': `The maximum time limit for an upload or download was exceeded. ${tryAgainOrContact}`,
  'storage/invalid-checksum': incorrectUpload,
  'storage/canceled': `The operation was cancelled.`,
  'storage/invalid-event-name': someoneMessedUp,
  'storage/invalid-url': someoneMessedUp,
  'storage/invalid-argument': someoneMessedUp,
  'storage/no-default-bucket': someoneMessedUp,
  'storage/cannot-slice-blob': `If this happened during an upload, try again, making sure not to modify the file during the upload. If this keeps happening, contact the technology department.`,
  'storage/server-file-wrong-size': incorrectUpload,
};

export function mapStorageError(error: firebase.storage.FirebaseStorageError) {
  return `${friendlyStorageMapping[error.code]} Firebase Error Code: ${
    error.code
  }. Firebase Error Message: ${error.message}`;
}
